import getSpaceRadius from './getSpaceRadius'

const findSpaceByCoordinates = (
  mouse,
  { dx, dy, spaces, xScale, yScale, rScale, zoomScale, transform: t, maxScale }
) => {
  const mx = mouse[0] - dx * t.k
  const my = mouse[1] - dy * t.k

  for (let i = 0; i < spaces.ids.length; i++) {
    const space = spaces.byId[spaces.ids[i]]

    const radius = getSpaceRadius({
      space: { w: space.w },
      k: t.k,
      rScale,
      maxScale,
    })

    const r = 1.1 * radius
    const x = xScale(space.x)
    const y = yScale(space.y)

    if (mx >= x - r && mx <= x + r && my >= y - r && my <= y + r) {
      return space
    }
  }

  return null
}

export default findSpaceByCoordinates
